import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 px-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-lg leading-6 font-medium" }, "Personal information"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }, "Use a permanent address where you can receive mail.")
], -1)
const _hoisted_2 = { class: "py-4 px-5 flex flex-wrap" }
const _hoisted_3 = { class: "w-full md:w-1/2 md:pr-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "block text-sm font-medium text-gray-700"
}, " First name ", -1)
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "w-full md:w-1/2 md:pr-1 mt-4 md:mt-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "block text-sm font-medium text-gray-700"
}, " Last name ", -1)
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "w-full md:w-1/2 md:pr-1 mt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Corporate email ", -1)
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "w-full md:w-1/2 md:pr-1 mt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, " Phone ", -1)
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end mt-4 px-5 py-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "bg-sky text-white rounded-md text-sm px-3 py-1.5"
  }, "Save")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", {
    class: "bg-white shadow-sm rounded-md divide-y",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "firstName",
            id: "firstName",
            class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
            placeholder: "David",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collectedData.firstName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.collectedData.firstName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "lastName",
            id: "lastName",
            class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
            placeholder: "Miller",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.lastName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.collectedData.lastName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "email",
            id: "email",
            class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
            placeholder: "david.miller@company.com",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.email) = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.collectedData.email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "phone",
            id: "phone",
            class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
            placeholder: "+1 (305) 264-4333",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.phone) = $event))
          }, null, 512), [
            [_vModelText, _ctx.collectedData.phone],
            [_directive_maska, '+1 (###) ###-####']
          ])
        ])
      ])
    ]),
    _hoisted_15
  ], 32))
}